import clsx from 'clsx';

import styles from './Spinner.module.css';
import { SpinnerProps } from './types';

const Spinner = ({ className, width = 'w-5', height = 'h-5' }: SpinnerProps) => {
  return (
    <div className={clsx(styles.spinnerContainer, `${className}`)}>
      <div className={clsx(styles.spinnerCircle, `!${width} !${height}`)}></div>
    </div>
  );
};

export default Spinner;
